'use client';
import { clientEnv } from '@/config/env/client';
import {
  trackClickCheckoutCardCTAWebappRegistrati,
  trackClickCheckoutRegistrati,
  trackClickHeaderAccediRegistrati,
} from '@/utils/trackingGtm';
import { useCallback } from 'react';

const PATIENT_WEBAPP_BASE_URL = clientEnv.NEXT_PUBLIC_WEBAPP_PATIENT_URL;
export interface CheckoutPatientInfo {
  email: string;
  name: string;
  surname: string;
  newsletterSubscribed: boolean;
  phone: string;
  taxCode: string;
}

export const usePatientWebapp = () => {
  const buildPatientQueryParams = useCallback((patientInfo: CheckoutPatientInfo) => {
    return new URLSearchParams({
      // signup auth
      type: 'email',
      username: patientInfo.email,
      // user info
      name: patientInfo.name,
      surname: patientInfo.surname,
      taxCode: patientInfo.taxCode,
      newsletterSubscribed: patientInfo.newsletterSubscribed.toString(),
      // contacts
      phone: patientInfo.phone,
      email: patientInfo.email,
      // force to send OTP
      automaticOtpSend: 'true',
    }).toString();
  }, []);

  const buildPatientWebappLoginQueryParams = useCallback(() => {
    return new URLSearchParams({
      type: 'email',
      callbackUrl: window.location.href,
    }).toString();
  }, []);

  const openPatientWebappSignupUrl = useCallback(
    (patientInfo: CheckoutPatientInfo) => {
      trackClickCheckoutRegistrati();

      if (!patientInfo.email) {
        window.location.href = `${PATIENT_WEBAPP_BASE_URL}/signup/request-otp?type=email`;
      } else {
        window.location.href = `${PATIENT_WEBAPP_BASE_URL}/signup/verify-otp?${buildPatientQueryParams(patientInfo)}`;
      }
    },
    [buildPatientQueryParams],
  );

  const openPatientWebappLoginPage = useCallback(() => {
    trackClickCheckoutCardCTAWebappRegistrati();

    const loginUrl = `${PATIENT_WEBAPP_BASE_URL}/login?${buildPatientWebappLoginQueryParams()}`;
    window.location.href = loginUrl;
  }, [buildPatientWebappLoginQueryParams]);

  const openPatientWebappBaseUrl = useCallback(() => {
    trackClickHeaderAccediRegistrati();

    window.location.href = PATIENT_WEBAPP_BASE_URL;
  }, []);

  return {
    openPatientWebappSignupUrl,
    openPatientWebappLoginPage,
    openPatientWebappBaseUrl,
  };
};
